import React, { useState } from "react";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import "./Home.scss";
import SpecialButton from "../UI/SpecialButton";

const Home = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { isAuthenticated } = useSelector((state) => state.auth);

  const imageArray = [
    "/images/header-image-1.jpg",
    "/images/header-image-3.jpg",
  ];

  const loadNextImage = () => {
    if (currentIndex + 1 !== imageArray.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setCurrentIndex(0);
    }
  };

  return (
    <div name="home" id="home" className={`home`}>
      <div className="image-container">
        <img src={imageArray[currentIndex]} alt="Header Image" />
        <div className="text-container-wrapper">
          <div className="text-container">
            <h1>Skip the Waiting Room</h1>
            <h2>
              Get an exclusive online consultation from a certified Orthopedic
              SURGEON now!
            </h2>
            <SpecialButton
              className="button-get-started"
              buttonAsLink={true}
              link={isAuthenticated ? "/consultation-form" : "/sign-in"}
            >
              GET STARTED
            </SpecialButton>
          </div>
          <ReactSVG
            onClick={loadNextImage}
            className="next-button"
            src="/icons/tools/hero-next-icon.svg"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
